<template>
  <v-ons-page>

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">
        {{ isEdit ? "Modifier ma vente" : "J'ai réalisé une vente" }}
      </div>
      <div class="right">
        <v-ons-toolbar-button v-if="isEdit" @click="deleteVenteConfirm">
          <v-ons-icon icon="trash"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
    </v-ons-toolbar>

    <div class="content">

      <app-error-msg :list="errorMsgList"></app-error-msg>

      <v-ons-list modifier="noborder perflist">

        <app-label input-id="inputCoop" label="Acheteur (coopérative, négoce, ...)" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputCoop" ref="inputCoop" v-model="vente.coop" placeholder="Entrez un nom"></app-input>

        <app-label input-id="inputTonne" label="Quantité (t)" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputTonne" ref="inputTonne" input-type="number" v-model.number="vente.tonne"
                   placeholder="Entrez un montant" input-step="0.001"></app-input>

        <app-label input-id="inputPrix" label="Prix net (€/t)" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputPrix" ref="inputPrix" input-type="number" v-model.number="vente.prix"
                   placeholder="Entrez un prix" input-step="0.01" modifier="longdivider input"></app-input>

        <template v-if="isEuronext">

          <v-ons-list-item modifier="nodivider label" expandable :expanded.sync="isShow.composition">
            <div class="center">
              {{ isShow.composition ? 'Masquer' : 'Afficher' }} la composition du prix net
            </div>

            <div class="expandable-content">

              <v-ons-list modifier="noborder">

                <app-label input-id="inputEcheance" label="Échéance"></app-label>
                <v-ons-list-item modifier="nodivider input">
                  <div class="center">
                    <v-ons-select :modifier="vente.echeance ? 'underbar' : 'underbar placeholder'" v-model="vente.echeance">
                      <option value="" hidden>Sélectionnez une échéance</option>
                      <option v-for="echeance in getEcheanceList(coursName, campagne)" :key="echeance"
                              :value="echeance">
                        {{ getLabelEcheance(echeance) }}
                      </option>
                    </v-ons-select>
                  </div>
                </v-ons-list-item>

                <app-label input-id="inputCours" label="Cours Euronext (€/t)" :error-msg-list="errorMsgList"></app-label>
                <app-input input-id="inputCours" ref="inputCours" input-type="number"
                           v-model.number="vente.cours" placeholder="Entrez le cours Euronext"
                           input-step="0.01"></app-input>

                <app-label input-id="inputBase" label="Base (€/t)" :error-msg-list="errorMsgList"></app-label>
                <app-input input-id="inputBase" ref="inputBase" input-type="number" v-model.number="vente.base"
                           placeholder="Entrez la base" input-step="0.01">
                  <div slot="left" class="left">
                    <v-ons-select modifier="underbar" v-model="isBaseNegatif" style="width: 35px">
                      <option value="0">&nbsp;+ (base positive)</option>
                      <option value="1">&nbsp;- (base negative)</option>
                    </v-ons-select>
                  </div>
                </app-input>

              </v-ons-list>

            </div>

          </v-ons-list-item>

        </template>

      </v-ons-list>

      <v-ons-list modifier="noborder perflist">

        <app-label input-id="inputDate" label="Date de la vente" :error-msg-list="errorMsgList"></app-label>
        <v-ons-list-item modifier="nodivider input">
          <div class="center">
            <v-ons-row>
              <v-ons-col width="30%" style="margin-right: 10%">
                <v-ons-select :modifier="vente.date.jour ? 'underbar' : 'underbar placeholder'"
                              v-model="vente.date.jour">
                  <option value="" hidden>Jour</option>
                  <option v-for="jour in 31" :key="jour" :value="(jour < 10 ? '0' : '') + jour + '/'">
                    {{ jour }}
                  </option>
                </v-ons-select>
              </v-ons-col>
              <v-ons-col width="60%">
                <v-ons-select :modifier="vente.date.mois ? 'underbar' : 'underbar placeholder'"
                              v-model="vente.date.mois" ref="inputDate">
                  <option value="" hidden>Mois Année</option>
                  <option v-for="mois in listMois" :key="mois.value" :value="mois.value">
                    {{ mois.label }}
                  </option>
                </v-ons-select>
              </v-ons-col>
            </v-ons-row>
          </div>
        </v-ons-list-item>

        <v-ons-list-item modifier="label" expandable :expanded.sync="isShow.comment">
          <div class="center">Ajouter un commentaire</div>
          <div class="expandable-content">
            <textarea @click="$event.stopPropagation()" class="textarea textarea--transparent"
                      rows="3" placeholder="Écrire ici..." v-model="vente.comment"></textarea>
          </div>
        </v-ons-list-item>

      </v-ons-list>
      

      <footer class="footer--perfbutton">
        <v-ons-button modifier="large--cta perflarge" @click="saveVente">
          Enregistrer
        </v-ons-button>
      </footer>

    </div>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsCours from '../mixins/cours.js';

import { store } from '../store.js';

import AppErrorMsg from '../partials/ErrorMsg.vue';
import AppLabel from '../partials/Label.vue';
import AppInput from '../partials/Input.vue';

export default {
  mixins: [mixinsCommons, mixinsCours],
  components: { AppErrorMsg, AppLabel, AppInput },
  props: ['pageStack'],
  data() {
    return {
      refCulture: '',
      refDestination: '',
      vente: {
        coop: '',
        tonne: '',
        date: {
          jour: '',
          mois: ''
        },
        prix: '',
        cours: '',
        base: '',
        echeance: '',
        comment: ''
      },
      isShow: {
        composition: false,
        comment: false
      },
      isBaseNegatif: 0,
      indexVente: -1,
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    campagne() {
      return this.user.campagne;
    },
    nbFeuille() {
      return this.state.onboarding.nbFeuille;
    },
    referentiel() {
      return this.data.referentiel;
    },
    coursName() {
      return this.refCulture ? this.referentiel.cultures[this.refCulture].destinations[this.refDestination].cours : null;
    },
    isEuronext() {
      return this.coursName && this.referentiel.cours[this.coursName].echeances;
    },
    listMois() {
      return this.getListMois(this.campagne);
    },
    isEdit() {
      return this.indexVente > -1;
    }
  },
  watch: {
    'vente.base'(value) {
      if (value < 0) {
        this.isBaseNegatif = 1;
        this.vente.base = Math.abs(value);
      }
    }
  },
  methods: {
    saveVente() {
      if(this.isSubmit){
        return;
      }
      this.resetErrorMsgList();

      if (!this.vente.coop) {
        this.setErrorMsgList('inputCoop', "L'acheteur est obligatoire");
      }

      if (!this.vente.tonne) {
        this.setErrorMsgList('inputTonne', "La quantité est obligatoire");
      }

      if (!this.vente.date.mois) {
        this.setErrorMsgList('inputDate', "Le mois de la vente est obligatoire");
      }

      if (this.vente.prix === '' && ((this.vente.cours === '' && this.vente.base === '') || (this.vente.cours && this.vente.base))) {
        this.setErrorMsgList('inputPrix', "Le prix net est obligatoire");
      }

      if (Object.keys(this.errorMsgList).length) {
        this.$scrollTop();
        return;
      }

      this.isSubmit = true;

      var body = {
        id: this.user.id,
        date: this.user.date,
        ref_culture: this.refCulture,
        ref_destination: this.refDestination,
        data: {}
      };
      for (const key in this.vente) {
        if (key == 'date') {
          body.data.date = this.vente.date.jour + this.vente.date.mois;
        } else if (key == 'base' && this.vente.base !== '') {
          body.data.base = (parseInt(this.isBaseNegatif) ? -1 : 1) * this.vente.base;
        } else {
          body.data[key] = this.vente[key];
        }
      }
      if (this.isEdit) {
        body.index_vente = this.indexVente;
      }

      if (this.isEdit) {
        store.state.user.ventes[this.refCulture][this.refDestination].done.splice(this.indexVente, 1, body.data);
      } else {
        store.state.user.ventes[this.refCulture][this.refDestination].done.push(body.data);
      }
      this.ionicStorage.set('user', this.user);

      this.$emit('call-api', {
        call: {
          path: this.getPath('/vente'),
          data: body
        }
      });

      if (!this.isEdit && this.nbFeuille == 2) {
        store.state.onboarding.nbFeuille += 1;
        this.ionicStorage.set('onboarding', this.state.onboarding);
        store.state.badge.type = 'feuille';
        this.sendTrackEvent('onboarding feuille ' + this.nbFeuille);
      }

      this.pageStack.pop();
    },
    deleteVenteConfirm() {
      this.$ons.notification.confirm({
        modifier: this.$mdModifier,
        title: 'Attention !',
        message: "Êtes-vous sûr de vouloir supprimer cette vente ?",
        buttonLabels: ['Annuler', 'Supprimer'],
        cancelable: true,
        callback: function (index) {
          if (index === 1) { // -1 if canceled
            this.deleteVente();
          }
        }.bind(this)
      });
    },
    deleteVente() {
      store.state.user.ventes[this.refCulture][this.refDestination].done.splice(this.indexVente, 1);
      this.ionicStorage.set('user', this.user);

      this.$emit('call-api', {
        call: {
          method: 'DELETE',
          path: this.getPath('/vente'),
          data: {
            id: this.user.id,
            date: this.user.date,
            ref_culture: this.refCulture,
            ref_destination: this.refDestination,
            index_vente: this.indexVente
          }
        }
      });

      this.pageStack.pop();
    }
  },
  created() {
    if (this.isEdit) {
      this.setVente(this.user.ventes[this.refCulture][this.refDestination].done[this.indexVente]);
      var dateArray = this.vente.date.split('/');
      this.$set(this.vente, 'date', {
        jour: dateArray.length > 2 ? dateArray[0] + '/' : '',
        mois: dateArray[dateArray.length - 2] + '/' + dateArray[dateArray.length - 1]
      });
    } else {
      this.vente.date.mois = this.listMois[0].value;
    }
    if (this.refCulture && this.vente.base === '' && this.getDefaultDiff(this.referentiel.cultures[this.refCulture].destinations[this.refDestination]) < 0) {
      this.isBaseNegatif = 1;
    }
  },
  mounted() {
    if (this.vente.echeance !== '' || this.vente.cours !== '' || this.vente.base !== '') {
      this.isShow.composition = true;
    }
    if (this.vente.comment) {
      this.isShow.comment = true;
    }
  }
}
</script>
